// 所有模块公用路由
const publicRouter = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/error/:code',
    name: 'Error',
    meta: {
      title: 'Error',
      checkToken: false,
      layoutType: 'none'
    },
    component: () => import('@/components/RouterError.vue')
  },
  { path: '/:pathMatch(.*)*', redirect: '/error/404' }
];
export default publicRouter;
